import {ChangeDetectionStrategy, Component} from "@angular/core";


/** Inline skjema, benyttes sammen med inline-skjema-tittel, inline-skjema-blokk og inline-skjema-handlinger */
@Component({
    selector: 'inline-skjema',
    template: '<ng-content/>',
    styleUrls: ['./inline-skjema.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineSkjemaKomponent {


}
